export default __webpack_public_path__ + "static/media/anuncio-doacao.54570e91.png";